import { Button, Flex, HStack, Text, VStack } from "@chakra-ui/react";
import { useEffect } from "react";
import { RiAddFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import { openCreateExamDataModel } from "../../../modules/admin-modules/models/Actions";
import { getAllCoursesRequest } from "../../../modules/superadmin-modules/courses/Actions";

const SearchBar = ({ setAdd, setCourseId }) => {
  const dispatch = useDispatch();
  const count = useSelector((state) => state.superadminExams.count);

  const courses = useSelector((state) => state.courses.courses);

  const coursesOptions = courses?.map((data) => {
    return { value: data.id, label: data.name };
  });
  useEffect(() => {
    dispatch(getAllCoursesRequest());
  }, []);

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "white",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };
  return (
    <VStack w="100%" my="30px">
      <Flex alignItems="center" w="100%" justifyContent="space-between">
        <Text fontSize="24px" fontWeight="600" color="main_1">
          الاختبارات
        </Text>

        <HStack spacing="7px">
          <Button
            borderRadius="16px"
            leftIcon={<RiAddFill />}
            color="white"
            bg="main_1"
            _focus={{ outline: "none" }}
            onClick={() => {
              setAdd(true);
              dispatch(openCreateExamDataModel());
            }}
          >
            إضافة اختبار
          </Button>

          <LogoutMenu />
        </HStack>
      </Flex>

      <Text w="100%" fontSize="20px" textAlign="right">
        عدد الاختبارات :{count}{" "}
      </Text>
      <HStack
        w="100%"
        justifyContent="space-between"
        bg="#f5f5f5"
        mt="40px !important"
        p="10px"
        mb="-30px !important"
      >
        <HStack spacing="5px">
          <Select
            options={coursesOptions}
            onChange={(data) => setCourseId(data?.value)}
            styles={colourStyles}
            placeholder="الدورات"
            isClearable
          />
        </HStack>
      </HStack>
    </VStack>
  );
};

export default SearchBar;
